import { render, staticRenderFns } from "./MasqueradeUpgrade.vue?vue&type=template&id=73882118&"
import script from "./MasqueradeUpgrade.vue?vue&type=script&lang=ts&"
export * from "./MasqueradeUpgrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports